import * as React from 'react';

import { useBoolean, useLockFn } from 'ahooks';
import { Button, Divider, Form, Modal, notification, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import { CheckOutlinedIcon, DeleteOutlinedIcon } from 'components';
import { usePackagingModelValue } from 'context';
import { deletePackagingModel } from 'services';
import { PATHNAME } from 'utils';

const {
  LOCAL: {
    PACKAGING_MODELS: { BASE_URL: PACKAGING_MODELS_BASE_URL },
  },
} = PATHNAME;

const PackagingModelFormAction = () => {
  const [deleteModalInstance, deleteModalContextHolder] = Modal.useModal();
  const [deleteLoading, { toggle: toggleDeleteLoading }] = useBoolean();
  const { id, mode } = usePackagingModelValue();
  const navigate = useNavigate();

  const handleDeletePackagingModel = useLockFn(
    async ({
      id,
    }: Pick<Required<ReturnType<typeof usePackagingModelValue>>, 'id'>) => {
      toggleDeleteLoading();

      deletePackagingModel({ id })
        .then(() => {
          navigate(PACKAGING_MODELS_BASE_URL);
          notification.success({
            message: 'بسته‌بندی با موفقیت حذف شد.',
          });
        })
        .catch(message => {
          notification.error({
            message,
          });
        })
        .finally(() => {
          toggleDeleteLoading();
        });
    },
  );

  return (
    <div>
      <div className='px-6 pt-4'>
        <Typography.Title level={3} className='mb-0 text-base font-medium'>
          انتشار بسته‌بندی
        </Typography.Title>
      </div>

      <Divider className='mb-8 mt-4' />

      <div className='px-6'>
        <Typography.Paragraph>
          از طریق این بخش می‌توانید بسته‌بندی ساخته شده و یا ویرایش شده را منتشر
          کنید.
        </Typography.Paragraph>
      </div>

      <div className='flex flex-wrap-reverse items-center gap-2 p-6 *:m-0 *:shrink *:grow *:basis-40'>
        {mode === 'Update' ? (
          <Form.Item>
            <Button
              block
              danger
              className='flex items-center'
              loading={deleteLoading}
              icon={<DeleteOutlinedIcon />}
              onClick={async () => {
                const confirmed = await deleteModalInstance.confirm({
                  title: 'آیا از حذف این بسته‌بندی اطمینان دارید؟',
                  width: 500,
                });
                if (id && confirmed) {
                  handleDeletePackagingModel({ id });
                }
              }}
            >
              <span>حذف بسته‌بندی</span>
            </Button>
            {deleteModalContextHolder}
          </Form.Item>
        ) : null}

        <Form.Item>
          <Button
            block
            type='primary'
            htmlType='submit'
            icon={<CheckOutlinedIcon />}
          >
            {mode === 'Create' ? (
              <span>افزودن بسته‌بندی جدید</span>
            ) : (
              <span>ذخیره تغییرات</span>
            )}
          </Button>
        </Form.Item>
      </div>
    </div>
  );
};

export { PackagingModelFormAction };
